import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/common/Layout';
import HomePage from './pages/HomePage';
import LoginForm from './components/auth/LoginForm';
import SignupForm from './components/auth/SignupForm';
import ReportsPage from './pages/ReportsPage';
import DashboardPage from './pages/DashboardPage';
import OverviewReportPage from './pages/OverviewReportPage';
import ThreatAnalysisPage from './pages/ThreatAnalysisPage';
import ThreatExposurePage from './pages/ThreatExposurePage';
import MovementSecurityPage from './pages/MovementSecurityPage';
import SecurityAdvicePage from './pages/SecurityAdvicePage';
import RecommendedBaselineSRAPage from './pages/RecommendedBaselineSRAPage';
import ThreatMapReferencePage from './pages/ThreatMapReferencePage';
import CompleteReportPage from './pages/CompleteReportPage';
import SecurityPlanPage from './pages/SecurityPlanPage';
import ReportViewerPage from './pages/ReportViewerPage';
import ProfilePage from './pages/ProfilePage';
import SubscriptionPage from './pages/SubscriptionPage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import OverviewPage from './pages/OverviewPage';
import ServicesPage from './pages/ServicesPage';
import ReportsManagementPage from './pages/ReportsManagementPage';
import PDFViewerPage from './pages/PDFViewerPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ContactPage from './pages/ContactPage';
import SecurityIncidentMapPage from './pages/SecurityIncidentMapPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="signin" element={<LoginForm />} />
            <Route path="signup" element={<SignupForm />} />
            {/* Protected routes will be added here */}
            {/* Protected Routes */}
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="reports" element={<ReportsPage />}>
              <Route index element={<Navigate to="/reports/overview" replace />} />
              <Route path="overview" element={<OverviewReportPage />} />
              <Route path="threat-analysis" element={<ThreatAnalysisPage />} />
              <Route path="threat-exposure" element={<ThreatExposurePage />} />
              <Route path="movement-security" element={<MovementSecurityPage />} />
              <Route path="security-advice" element={<SecurityAdvicePage />} />
              <Route path="recommended-baseline-sra" element={<RecommendedBaselineSRAPage />} />
              <Route path="threat-map-reference" element={<ThreatMapReferencePage />} />
              <Route path="complete-report" element={<CompleteReportPage />} />
              <Route path="security-plan" element={<SecurityPlanPage />} />
              <Route path="view/:level/:id" element={<ReportViewerPage />} />
            </Route>

            {/* Additional Routes */}
            <Route path="profile" element={<ProfilePage />} />
            <Route path="subscription" element={<SubscriptionPage />} />
            <Route path="subscription/success" element={<SubscriptionSuccessPage />} />
            
            {/* About and Services Routes */}
            <Route path="about" element={<OverviewPage />} />
            <Route path="services" element={<ServicesPage />} />
            
            {/* Reports Management Route */}
            <Route path="reports-management" element={<ReportsManagementPage />} />
            
            {/* PDF Viewer Route */}
            <Route path="pdf-viewer" element={<PDFViewerPage />} />
            
            {/* Security Incident Map */}
            <Route path="incident-map" element={<SecurityIncidentMapPage />} />
            
            {/* Legal Pages */}
            <Route path="terms" element={<TermsOfServicePage />} />
            <Route path="privacy" element={<PrivacyPolicyPage />} />
            <Route path="contact" element={<ContactPage />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
